// extracted by mini-css-extract-plugin
export default {"header":"pageHeader_header__8yy+x","title":"pageHeader_title__9GuCc","backBtn":"pageHeader_backBtn__goddk","children":"pageHeader_children__neZP6"};